import common from "../common";
import BaseStage from "./BaseStage";
import doughRolling from "./Stage_Cutting_Objects/SubStages/DoughRolling";
import cutterSelection from "./Stage_Cutting_Objects/SubStages/CutterSelection";
import cuttingDough from "./Stage_Cutting_Objects/SubStages/CuttingDough";

export default class Stage_Cutting extends BaseStage {
    constructor() {
        super("cutting_1");
        this._rollingStage  = new doughRolling();
        this._selectCutterStage = new cutterSelection();
        this._cutDoughStage = new cuttingDough();
        this._rollingStageComplete = false;
        this._continueButton = null;
        this._bindings = {};
    }

    init() {
        super.init(P3.audio.playMusic("music_ambient_music_loop_00"));

        let bk = new PIXI.Sprite(P3.assets.texture('bg_table'));
        bk.anchor.set(0.5);
        bk.width = 1900;
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChildAt(bk, 0);

        this._bindings.rollerComplete = this._rollingStage._signals.rollingComplete.add(this.onRollingComplete, this);
        this._rollingStage._bindings.help = this.signals.helpTutorial.add(()=>{
            this._rollingStage.createTutorial();
        }, this._rollingStage);

        this._bindings.cutterSelected = this._selectCutterStage._signals.cutterSelected.add(this.onCutterSelected, this);
        this._bindings.cuttingComplete = this._cutDoughStage._signals.cuttingComplete.add(()=>{
            new P3.utils.TWEEN.Tween(this._continueButton.scale, this.tweens)
                .to({
                    x: .8,
                    y: .8
                }, 340)
                .easing(P3.utils.Easing.Back3.Out)
                .onStart(()=>{
                    this._continueButton.visible = true;
                })
                .onComplete(()=>{
                    //console.log("finished scaling");
                })
                .start();
            this._bindings.cuttingComplete.detach();
        }, this);

        this.addChild(this._rollingStage);
        this.addChild(this._cutDoughStage);

        this.createUI();

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_off");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.icon = P3.assets.texture("icon_play_large_off");
        this._continueButton = new P3.Button(states);
        this._continueButton.visible = false;
        this._continueButton._counter = 0;
        this._continueButton.signals.click.add(this.onContinueButtonClick, this);
        this.addChild(this._continueButton);
    }

    destroy() {
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};

        this._rollingStage.destroy();
        this._selectCutterStage.destroy();

        super.destroy();
    }

    resize() {
        super.resize();
        this._continueButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._continueButton.y = common.STAGE_HEIGHT * 0.5 + 225;
    }

    animateIn() {
        super.animateIn();
    }

    update() {
        super.update();
        this._rollingStage.update();
        if(this._rollingStageComplete)
            this._selectCutterStage.update();
        this._cutDoughStage.update();
    }

    pauseGame() {
        super.pauseGame();
    }

    resumeGame() {
        super.resumeGame();
    }

    onRollingComplete(){
        this._rollingStageComplete = true;
        this._selectCutterStage.init();
        this.addChild(this._selectCutterStage);
        this._helpStage = "cutting_2";
        this._selectCutterStage._bindings.help = this.signals.helpTutorial.add(()=>{
            this._selectCutterStage.createTutorial();
        }, this._selectCutterStage);
    }

    onCutterSelected(cutter){
        this._cutDoughStage.init(this._rollingStage._dough, cutter);
        this._rollingStage.removeChild(this._rollingStage._dough);
        this._rollingStage.destroy();
        this._helpStage = "cutting_3";
        this._cutDoughStage._bindings.help = this.signals.helpTutorial.add(()=>{
            this._cutDoughStage.createTutorial();
        }, this._cutDoughStage);
    }

    onContinueButtonClick(){
        if(this._continueButton._counter === 0){
            this._cutDoughStage.createTray();
            new P3.utils.TWEEN.Tween(this._continueButton.scale, this.tweens)
                .to({
                    x: 0, y: 0
                }, 340)
                .easing(P3.utils.Easing.Back3.In)
                .start();
        }
        else{
            this.signals.next.dispatch();
        }
        this._continueButton._counter++;
        P3.audio.playSound("sfx_stage_complete_00");
    }
}